export default [
  {
    path: "/gallery",
    component: () => import(/* webpackChunkName: "shop" */ "@/views/global/Index"),
    children: [
      {
        path: "",
        name: "gallery.index",
        component: () => import(/* webpackChunkName: "shop" */ "@/views/app/Gallery"),
        meta: { layout: "HorizontalBar" },
      },
      {
        path: "*",
        redirect: "/gallery",
      },
    ],
  },
  {
    path: "/artist",
    component: () => import(/* webpackChunkName: "shop" */ "@/views/global/Index"),
    children: [
      {
        path: ":slug",
        name: "app.artist.details",
        component: () =>
          import(/* webpackChunkName: "shop" */ "@/views/app/artist/ArtistView"),
        meta: { layout: "HorizontalBar" },
      },
    ],
  },
  {
    path: "/shop",
    component: () =>
      import(/* webpackChunkName: "shop" */ "@/views/global/Index"),

    children: [
      {
        path: "",
        name: "shop.index",
        component: () =>
          import(/* webpackChunkName: "shop" */ "@/views/shop/Index"),
        meta: { layout: "HorizontalBar" },
      },
      {
        path: ":orgSlug",
        name: "shop.organization",
        component: () =>
          import(/* webpackChunkName: "shop" */ "@/views/shop/Organization"),
        meta: { layout: "HorizontalBar" },
      },
      // {
      //   path: ":orgSlug/products",
      //   name: "shop.organization.products",
      //   component: () =>
      //     import(/* webpackChunkName: "shop" */ "@/views/shop/OrganizationProducts"),
      //   meta: { layout: "HorizontalBar" },
      // },
      // {
      //   path: ":orgSlug/products/:productId",
      //   name: "shop.organization.product",
      //   component: () =>
      //     import(/* webpackChunkName: "shop" */ "@/views/shop/ProductDetail"),
      //   meta: { layout: "HorizontalBar" },
      //   beforeEnter: (to, from, next) => {
      //     // Mark if this is a direct navigation to the product page
      //     to.params.directNavigation = !from.name || !from.name.includes('shop.organization');
      //     next();
      //   }
      // },
      // {
      //   path: ":orgSlug/products/collection/:collectionId",
      //   name: "shop.organization.collection",
      //   component: () =>
      //     import(/* webpackChunkName: "shop" */ "@/views/shop/ProductCollection"),
      //   meta: { layout: "HorizontalBar" },
      // },
      {
        path: ":orgSlug/:partyId",
        name: "shop.party",
        component: () =>
          import(/* webpackChunkName: "shop" */ "@/views/shop/Party"),
        meta: { layout: "HorizontalBar" },
      },
      {
        path: ":orgSlug/:partyId/gallery",
        name: "shop.party.gallery",
        component: () =>
          import(
            /* webpackChunkName: "shop" */ "@/views/shop/PartyFullGallery"
          ),
        meta: { layout: "HorizontalBar", hiddenAppBar: true },
      },
      {
        path: "*",
        redirect: "/app",
      },
    ],
  },
];
